import { Section } from "@nexcloud/nc-ui";

const MetricsTab = () => {
  return <Section>MetricsTab</Section>;
};

export default MetricsTab;
